/*
 * Server maintenance notice shown as a popup once after every login (opened from BaseComponent).
 * The popup stops showing automatically after showUntil.
 */

export const MAINTENANCE_NOTICE = {
  showUntil: '2026-11-15T23:59:59',
  title: 'Scheduled Server Maintenance',
  titleTamil: 'சேவையகப் பராமரிப்பு அறிவிப்பு',
  fromLabel: 'From / முதல்',
  from: '14.11.2026, 00:00 hrs',
  toLabel: 'To / வரை',
  to: '15.11.2026, 23:59 hrs',
  english: 'MiMaS server maintenance is scheduled from 14.11.2026 at 00:00 hrs to 15.11.2026 at 23:59 hrs. All MiMaS application services will remain unavailable during this period. Users are requested to plan their activities accordingly.',
  tamil: 'MiMaS சேவையகப் பராமரிப்புப் பணிகள் 14.11.2026 அன்று 00:00 மணி முதல் 15.11.2026 அன்று 23:59 மணி வரை நடைபெற உள்ளன. இக்காலகட்டத்தில் MiMaS இணையதளத்தின் அனைத்துச் சேவைகளும் செயல்படாது. எனவே, பயனர்கள் தங்களது பணிகளை அதற்கேற்ப திட்டமிட்டுக் கொள்ளுமாறு கேட்டுக்கொள்ளப்படுகிறார்கள்.',
  okLabel: 'OK, Continue'
};

// localStorage is cleared on login and logout, so this flag shows the notice once per login
export const MAINTENANCE_NOTICE_SEEN_KEY = 'maintenanceNoticeSeen';
